// @ts-nocheck
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskCEP {
  public maxLength = 8;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    if (newValue.length > this.maxLength) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }

    return { newValue, newCursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    try {
      if (value.length <= 5) {
        return { formatedValue: value, formatedCursorPosition: cursorPosition };
      } else {
        const formatedValue = value.replace(/^(\d{5})(\d{1,3})$/, '$1-$2');
        const formatedCursorPosition = cursorPosition < 5 ? cursorPosition : cursorPosition + 1;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      }
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['CEP']];
  }
}
